module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c20f444ba23534c6be1f9910176785db.png";